import { securityCreateToken, getProfile, refreshApiToken } from 'utils/api';
import { SET_AUTH, SET_PROFILE, LOG_OUT } from './types';
import moment from 'moment';
import { removeState } from '../../localStorage';
import store from 'redux/configureStore';
import { toast } from 'react-toastify';

export function setProfile() {
    return dispatch => {
        return getProfile().then(res => {
            dispatch({
                type: SET_PROFILE,
                data: res.content
            });
        });
    };
}

export function logout() {
    if(store.getState().auth.isAuthenticated) {
        return dispatch => {
            // makeLogout()
            // .then(() => {
                removeState();
                dispatch({ type: LOG_OUT });
            // })
            // .catch(err => {
            //     removeState();
            //     dispatch({ type: LOG_OUT });
            // });
        };
    }
}

export function login(username, password) {
    return dispatch => {
        const params = {
            _username: username,
            _password: password,
        };

        /*return fetch('/api/v1/admin/security/get_token', {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                mode: 'cors', // no-cors, *cors, same-origin
                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                credentials: 'same-origin', // include, *same-origin, omit
                headers: {
                //'Content-Type': 'application/json'
                'Content-Type': 'application/x-www-form-urlencoded',
                },
                redirect: 'follow', // manual, *follow, error
                referrerPolicy: 'no-referrer', // no-referrer, *client
                body: JSON.stringify(params) // body data type must match "Content-Type" header
            })
                .then((response) => {
                    return response.json();
                })
                .then((res) => {
                    const now = moment().format('YYYY-MM-DDTHH:mm:ssZ');
                    const then = res.datetime;
                    const timeOffset =
                        moment(now, 'YYYY-MM-DDTHH:mm:ssZ').diff(
                            moment(then, 'YYYY-MM-DDTHH:mm:ssZ')
                        ) / 1000;

                    const authData = {
                        username: username,
                        wsseToken: res.content.token,
                        timeOffset,
                    };
                    dispatch({type: SET_AUTH, data: authData});
                })
                .catch(err => {
                    toast.error(err.message);
                    console.log('login err: ', err)
                })*/ 
        return securityCreateToken(params).then(res => {
            const now = moment().format('YYYY-MM-DDTHH:mm:ssZ');
            const then = res.datetime;
            const timeOffset =
                moment(now, 'YYYY-MM-DDTHH:mm:ssZ').diff(
                    moment(then, 'YYYY-MM-DDTHH:mm:ssZ')
                ) / 1000;

            const authData = {
                username: username,
                wsseToken: res.content.token,
                timeOffset,
            };
            dispatch({type: SET_AUTH, data: authData});
        })
        .catch(err => {
            toast.error(err.message);
            console.log('login err: ', err)
        });
    };
}

export function refreshTokenAction(object) {
    return dispatch => {
        return refreshApiToken(object)
            .then(res => {
                const now = moment().format('YYYY-MM-DDTHH:mm:ssZ');
                const then = res.datetime;
                const timeOffset =
                    moment(now, 'YYYY-MM-DDTHH:mm:ssZ').diff(
                        moment(then, 'YYYY-MM-DDTHH:mm:ssZ')
                    ) / 1000;
                const authData = {
                    ...store.getState().auth,
                    wsseToken: res.content.token,
                    timeOffset
                };               
                dispatch({type: SET_AUTH, data: authData});
            })
            .catch((error) => {
                console.log('login error: ', error)
                /*makeLogout()
                    .then(() => {
                        removeState();
                        dispatch({ type: LOG_OUT });
                    })
                    .catch(err => {
                        removeState();
                        dispatch({ type: LOG_OUT });
                    });*/
            });
    };
}